import classNames from 'classnames';
import { useState, useEffect } from 'react';

const ClockSvg = () => (
    <svg className="w-3.5 h-3.5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 4V8L10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const formatTime = (timeLeft) => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const LimitedTimeOfferCountdown = ({ time, color = "black" }) => {
    const [timeLeft, setTimeLeft] = useState(time); // 20 minutes in seconds

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime <= 0) {
                    clearInterval(countdown);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(countdown);
    }, []);

    return (
        <div className={classNames("flex gap-2", {
            "text-white": color === "white",
            "text-[#001C3D]": color === "black",
        })}>
            {formatTime(timeLeft)}
        </div>
    )
}